import { AnyAction } from 'redux';
import { Action } from 'store/store';
import { WidgetActionType } from '../actions';
import { WidgetSharedStateSection } from './WidgetsSharedState';
import {
    SetAlgorithmParametersSharedStatePayload,
    SetAlgorithmParametersSharedStateAction,
} from './algoParameters/actions';

interface CleanupWidgetSharedStatePayload {
    preservedSections: WidgetSharedStateSection[];
}

export type CleanupWidgetSharedStateAction = Action<
    WidgetActionType.WIDGET_CLEANUP_SHARED_STATE,
    CleanupWidgetSharedStatePayload
>;

export function cleanupWidgetSharedStateAction(
    preservedSections: WidgetSharedStateSection[]
): CleanupWidgetSharedStateAction {
    return {
        type: WidgetActionType.WIDGET_CLEANUP_SHARED_STATE,
        payload: {
            preservedSections,
        },
    };
}

export interface SetWidgetSharedStateGenericPayload<
    TSharedSection extends WidgetSharedStateSection,
    TSharedSectionAction extends AnyAction,
> {
    sharedSection: TSharedSection;
    sharedSectionAction: TSharedSectionAction;
}

export type SetWidgetSharedStateGenericAction<
    TSharedSection extends WidgetSharedStateSection,
    TSharedSectionAction extends AnyAction,
> = Action<
    WidgetActionType.WIDGET_SET_SHARED_STATE,
    SetWidgetSharedStateGenericPayload<TSharedSection, TSharedSectionAction>
>;

export function setWidgetSharedStateSection<
    TSharedSection extends WidgetSharedStateSection,
    TSharedSectionAction extends AnyAction,
>(
    sharedSection: TSharedSection,
    sharedSectionAction: TSharedSectionAction
): SetWidgetSharedStateGenericAction<
    WidgetSharedStateSection,
    TSharedSectionAction
> {
    return {
        type: WidgetActionType.WIDGET_SET_SHARED_STATE,
        payload: {
            sharedSection,
            sharedSectionAction,
        },
    };
}

type SetWidgetSharedStatePayload = SetAlgorithmParametersSharedStatePayload;

type SetWidgetSharedStateAction = SetAlgorithmParametersSharedStateAction;

export type WidgetSharedStatePayload =
    | CleanupWidgetSharedStatePayload
    | SetWidgetSharedStatePayload;

export type WidgetSharedStateAction =
    | CleanupWidgetSharedStateAction
    | SetWidgetSharedStateAction;
